"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TruckIcon = exports.OriginalShippingFee = exports.Image = exports.FormControlWrapper = exports.EstimatedDeliveryAndOriginalFee = exports.EstimatedDelivery = exports.DeliveryInfo = exports.DeliveryFee = exports.CourierRadio = exports.CourierInfo = exports.CourierDescription = exports.CourierControl = exports.CourierBoxWrapper = exports.CourierBoxRoot = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const CourierBoxRoot = exports.CourierBoxRoot = (0, _mui.styled)('div')(({
  ownerState: {
    isBoundCourier
  },
  theme
}) => ({
  width: `100%`,
  display: 'flex',
  flexWrap: 'wrap',
  borderTop: `1px solid ${theme.palette.grey[200]}`,
  marginTop: theme.spacing(3),
  paddingTop: theme.spacing(3),
  ...(isBoundCourier && {
    position: 'relative',
    width: `calc(100% - ${theme.spacing(6)})`,
    left: theme.spacing(3),
    padding: theme.spacing(3, 0, 4, 0)
  })
}));
const CourierBoxWrapper = exports.CourierBoxWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  width: '100%',
  overflow: 'hidden',
  position: 'relative',
  borderRadius: theme.spacing(2)
}));
const CourierInfo = exports.CourierInfo = (0, _mui.styled)('div')(({
  ownerState: {
    isBoundCourier
  },
  theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  ...(!isBoundCourier && {
    paddingLeft: theme.spacing(7)
  })
}));
const CourierDescription = exports.CourierDescription = (0, _mui.styled)('figure')({
  margin: 0
});
const Image = exports.Image = (0, _mui.styled)('img')(({
  ownerState: {
    isDisabled,
    isFlatSelection
  },
  theme
}) => ({
  height: isFlatSelection ? 25 : 20,
  width: 'auto',
  ...(!isFlatSelection && {
    marginBottom: theme.spacing(3)
  }),
  ...(isDisabled && {
    opacity: 0.5
  }),
  '& ~ figcaption': {
    color: theme.palette.grey.A700,
    ...(isDisabled && {
      color: theme.palette.grey.A400
    })
  }
}));
const DeliveryInfo = exports.DeliveryInfo = (0, _mui.styled)('div')({
  textAlign: 'right',
  zIndex: 1
});
const DeliveryFee = exports.DeliveryFee = (0, _mui.styled)(_mui.Typography)(({
  ownerState: {
    isDisabled
  },
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(2),
  justifyContent: 'end',
  ...(isDisabled && {
    color: theme.palette.grey.A400
  })
}));
const OriginalShippingFee = exports.OriginalShippingFee = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textDecoration: 'line-through',
  color: theme.palette.grey.A700
}));
const EstimatedDelivery = exports.EstimatedDelivery = (0, _mui.styled)(_mui.Typography)(({
  ownerState: {
    isDisabled
  },
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: theme.spacing(3),
  justifyContent: 'flex-end',
  ...(isDisabled && {
    color: theme.palette.grey.A400
  })
}));
const TruckIcon = exports.TruckIcon = (0, _mui.styled)(_icons.Truck)(({
  theme
}) => ({
  marginRight: theme.spacing(2)
}));
const FormControlWrapper = exports.FormControlWrapper = (0, _mui.styled)(_mui.FormControl)(({
  theme
}) => ({
  width: `calc(100% - ${theme.spacing(6)})`,
  padding: theme.spacing(0, 3, 4, 3),
  marginTop: theme.spacing(-3)
}));
const CourierControl = exports.CourierControl = (0, _mui.styled)(_mui.FormControlLabel)({
  position: 'relative',
  margin: 0,
  display: 'block'
});
const CourierRadio = exports.CourierRadio = (0, _mui.styled)(_mui.Radio)(({
  theme
}) => ({
  position: 'absolute',
  left: theme.spacing(-2),
  top: theme.spacing(4)
}));
const EstimatedDeliveryAndOriginalFee = exports.EstimatedDeliveryAndOriginalFee = (0, _mui.styled)(_mui.Typography)({
  display: 'flex',
  justifyContent: 'space-between'
});